// extracted by mini-css-extract-plugin
export default {"main":"Xba-z"};